import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { authActions, settingsActions } from 'store';
import { v4 as uuid } from 'uuid';
import { yupResolver } from '@hookform/resolvers/yup';
import { useForm } from 'react-hook-form';
import { Images } from 'assets/images';
import { PURPOSES_OF_DELETING_ACCOUNT } from './data';
import { INPUT_PASSWORD_TYPE, INPUT_TEXT_TYPE } from 'utils/constant';
import { deleteAccountSchema } from 'validationSchemes/settingsPageScheme';
import { SettingsPageLayout } from 'Layout/SettingsPageLayout';
import { selectSettings } from 'store/settings/selector';
import { RadioCheckbox } from 'containers/settings/styled';
import {
  Form,
  QuestionToUser,
  PurposeOfDeleteAccountBlock,
  PurposeContainer,
  PurposeText,
  DeleteUserAccountBlock,
  DeleteButton,
  ModalForSubmit,
  ModalContent,
  QuestionBlock,
  AnsweringBlock,
  ButtonYes,
  ButtonNo,
  FinalQuestion,
  InputBlock,
} from './styled';
import {
  ErrorMessage,
  PasswordVisibleIcon,
  StyledInput,
} from 'components/inputs/ChangeInput/styled';

export const DeleteAccount = () => {
  const { isDeleteUserSuccess } = useSelector(selectSettings);
  const {
    register,
    handleSubmit,
    getValues,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(deleteAccountSchema),
  });
  const [passwordVisibility, setPasswordVisibility] = useState(INPUT_PASSWORD_TYPE);
  const [deleteModal, setDeleteModal] = useState(false);
  const dispatch = useDispatch();

  const deleteAccount = () => {
    const { reason, password } = getValues();
    setDeleteModal(!deleteModal);

    dispatch(settingsActions.deleteAccount({ password, reason }));
  };

  const closeModal = () => {
    setDeleteModal(false);
  };

  const handleChangeInputType = () => {
    setPasswordVisibility(
      passwordVisibility === INPUT_PASSWORD_TYPE
        ? INPUT_TEXT_TYPE
        : INPUT_PASSWORD_TYPE,
    );
  };

  useEffect(() => {
    if (isDeleteUserSuccess) {
      dispatch(authActions.logOut());
    }
  }, [isDeleteUserSuccess]);

  const onSubmit = (data, e) => {
    e.preventDefault();
    setDeleteModal(true);
  };

  return (
    <SettingsPageLayout>
      <DeleteUserAccountBlock id="delete-account">
        <Form onSubmit={handleSubmit(onSubmit)}>
          <QuestionToUser>Why do you want to delete your account?</QuestionToUser>
          <PurposeOfDeleteAccountBlock>
            {PURPOSES_OF_DELETING_ACCOUNT.map((element) => (
              <PurposeContainer key={uuid()} htmlFor={element.value}>
                <RadioCheckbox
                  type="radio"
                  id={element.value}
                  value={element.purpose}
                  {...register('reason')}
                  error={errors?.reason?.message}
                />
                <PurposeText error={errors?.reason?.message}>
                  {element.purpose}
                </PurposeText>
              </PurposeContainer>
            ))}
          </PurposeOfDeleteAccountBlock>
          <InputBlock>
            <StyledInput
              placeholder="Write your password"
              type={passwordVisibility}
              {...register('password')}
              error={errors?.password?.message}
            />
            <PasswordVisibleIcon
              src={
                passwordVisibility === INPUT_PASSWORD_TYPE
                  ? Images.passwordClosedEye
                  : Images.passwordOpenedEye
              }
              onClick={handleChangeInputType}
            />
            <ErrorMessage>{errors?.password?.message ?? null}</ErrorMessage>
          </InputBlock>

          <DeleteButton type="submit">Delete Account</DeleteButton>
        </Form>
        {deleteModal ? (
          <ModalForSubmit>
            <ModalContent>
              <QuestionBlock>
                <FinalQuestion>
                  Are you sure, you want to delete your account?
                </FinalQuestion>
                <AnsweringBlock>
                  <ButtonYes onClick={deleteAccount}>Yes</ButtonYes>
                  <ButtonNo onClick={closeModal}>No</ButtonNo>
                </AnsweringBlock>
              </QuestionBlock>
            </ModalContent>
          </ModalForSubmit>
        ) : null}
      </DeleteUserAccountBlock>
    </SettingsPageLayout>
  );
};
